import React, { useState, } from 'react'
import { Typography } from '@material-ui/core'
import { Col, FormGroup, Input, Row } from 'reactstrap'

function AmountOfReseourcesSelection({ onChange, title, maxamount, disabled }) {
  const [amount, setAmount] = useState(1)

  const updateAmount = (value) => {
    const a = Number(value)
    setAmount(a)
    onChange(a)
  }

  return (
    <Row  className={'loose'} key={'amount_selection'}>
      <Col>
        <Typography variant='body2' className='item-name'>
          {title}
        </Typography>
      </Col>
      <Col className={'text-right'} style={{ justifyItems: 'end'}}>
        <FormGroup style={{ marginBottom: 0 }} disabled={disabled}>
          <Input
            type='select'
            name='select'
            id='itemSelect'
            style={{ maxWidth: 60, marginBottom: 0 }}
            value={amount || 1}
            onChange={(e) => updateAmount(e.target.value)}
          >
            {Array.from({ length: maxamount }, (_, i) => i + 1).map((a, i) => (
              <option value={a} key={'ep-' + i}>{a}</option>
            ))}
          </Input>
        </FormGroup>
      </Col>
    </Row>
  )
}

export default AmountOfReseourcesSelection
